import React, {useCallback} from 'react';
import clsx from "clsx";
import {NoRecordIcon} from "presentation/common/components/style-guide/icons";
import {Button} from "presentation/common";
import {useHistory} from "react-router-dom";
import AppRouters from "application/globals/app-routers";

import styles from './empty-message.module.scss';

export const EmptyMessage = () => {

  const history = useHistory();

  const onNewRequest = useCallback(
    () => {
      history.push(AppRouters.newReport)
    },
    [history],
  );

  return (
    <div className={clsx("w-full h-full p-4 flex justify-center items-center flex-col", styles.container)}>
      <NoRecordIcon/>
      <h3 className="pt-4 pb-1 text-center" style={{color: '#505050'}}>
        ¡Solicite Inscripciones!
      </h3>
      <p className="pb-4">Obtenga los documentos de su vehículo acá.</p>
      <Button label="Solicitar" onClick={onNewRequest}/>
    </div>
  )
};
